/* eslint-disable @typescript-eslint/camelcase */
import { connect } from 'react-redux';
import get from 'lodash/get';
import * as actions from './TopNavActions';
import { burgerMenuItems, get_navigation } from './TopNavSelector';
import TopNavView from './TopNavView';
import {
  currentClientSelector,
  isConsumerArea as isConsumerAreaSelector,
  isOrionClientSelector,
  selectHasMobileNavigation,
} from '../../CommonSelectors/CommonAreaSelector';
import { hasTwoFactorAuthenticationSelector } from '../../ConsumerArea/ConsumerAreaSelector';
import { currentRouteSelector } from '../../CommonComponents/Router/Selector';
import { open as whatIfsVisible } from '../../WhatIfs/WhatIfsSelector';

const mapStateToProps = (state, ownProps) => {
  const subdivision = state.ConsumerTopNav;
  const currentClientComponentName = get(ADV, 'data.user.ComponentName');
  const currentClient = currentClientSelector(state);
  const hasAccess = currentClientComponentName !== 'NoClientAccess';
  const isOrionClient = isOrionClientSelector(state);
  const hasContactAdvisorAccess =
    (isOrionClient && ADV.info.showAdvisorInfo) ||
    (!isOrionClient && ADV.entities.isOptedIn('ContactAdviser'));

  return {
    absolute_logo_url: ownProps.absolute_logo_url,
    allow_full_screen: subdivision ? subdivision.allow_full_screen : true,
    client: ownProps.client,
    navigation: get_navigation(state, ownProps),
    workflow: subdivision ? subdivision.workflow : false,
    hasAccess,
    showContactAdviser:
      ADV.util.env('isConsumerArea') &&
      ADV.info &&
      !ADV.info.isPresentationMode &&
      hasAccess &&
      hasContactAdvisorAccess,
    isNotInWorkflows: ownProps.client.ConsumerAccessWorkflow === -1,
    isSidebarCollapsed: ownProps.isSidebarCollapsed,
    isSidebarVisible: ownProps.isSidebarVisible,
    isConsumerArea: isConsumerAreaSelector(state),
    hasTwoFactorAuthentication: hasTwoFactorAuthenticationSelector(state),
    currentClient,
    route: currentRouteSelector(state),
    burgerMenuItems: burgerMenuItems(),
    areWhatIfsVisible: whatIfsVisible(state, { clientId: currentClient.Id }),
    isOrionClient,
    hasMobileNavigation: selectHasMobileNavigation(state),
  };
};

const mapDispatchToProps = dispatch => ({
  initialize(currentClient, isConsumerArea) {
    dispatch(actions.initialize(currentClient, isConsumerArea));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(TopNavView);
